import { initialListPaginationMeta } from "utils/helpers/pagination";

import { FrontClearanceForm, FrontClearanceState } from "../types";

export const initialFrontClearanceForm: FrontClearanceForm = {
  manufacturer: "",
  masterModel: "",
  year: "",
  driverCabin: "",
  bodyType: "",
  optimalDistance: "",
  minimalDistance: "",
  note: "",
};

export const initialFrontClearanceMeta = initialListPaginationMeta;

export const initialState: FrontClearanceState = {
  loading: false,
  saving: false,
  list: [],
  page: 1,
  perPage: 20,
  meta: initialFrontClearanceMeta,
  error: null,
  manufacturerFilter: "ALL",
  masterModelFilter: "ALL",
  yearFilter: "ALL",
  isAddModalOpen: false,
  form: initialFrontClearanceForm,
};
